import { render, staticRenderFns } from "./TerrainDigging.vue.html?vue&type=template&id=e4b8efec&lang=html&external"
import script from "./TerrainDigging.vue.js?vue&type=script&lang=js&external"
export * from "./TerrainDigging.vue.js?vue&type=script&lang=js&external"
import style0 from "./TerrainDigging.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports